<template>
	<div class="w-100 ">
        <div class="globalHeader w-100">
            <header class="text-right d-flex align-items-center justify-content-between">
                <div class="d-flex">
                    <div class="Steplogo ">
                        <router-link to="/dashboard" class="green">
                            <img class="d-none d-xl-block" src="/static/fxView/images/logo-black.svg" alt="fxView">
                            <img class="d-xl-none" src="/static/fxView/images/fxview_logo_white.svg" alt="fxView">
                        </router-link>
                    </div>
                </div>
                <div class="backSection">
                    <router-link to="/dashboard" class="back"><feather type="home" ></feather> </router-link>
                    <router-link to="/step1" class="back" v-if="$route.name == 'fxView.step_four' && parseInt(get_user.step) != 3" ><feather type="chevron-left"></feather> </router-link>
                    <router-link to="/step2" class="back" v-else-if="$route.name == 'fxView.step_five' && parseInt(get_user.step) != 3" ><feather type="chevron-left" ></feather> </router-link>
                </div>
            </header>
        </div>
        <div class="d-flex justify-content-center align-items-center stepListing w-100" v-if="parseInt(get_user.step) != 4">
            <ul class="d-flex justify-content-between" style="overflow-x: auto;">
                <li class="nav-item d-flex align-items-center text-nowrap ">  
                    <router-link :style="{pointerEvents: 'none'}" to="/step1"  :class="($route.name == 'fxView.step_one')?'active':''">
                        <figure><img src="../../../../static/fxView/images/personal-information.svg" alt="fxView"></figure>
                        <!-- <h3>Step 1</h3> -->
                        <h4>{{$t('steps_heading1')}}</h4>
                    </router-link>
                    <span><feather type="chevron-right" ></feather></span>
                </li>
                <li  class="nav-item d-flex align-items-center text-nowrap"> 
                    <router-link :style="{pointerEvents: 'none'}" to="/step2" :class="($route.name == 'fxView.step_two')?'active':''">
                        <figure><img src="../../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
                        <h4>{{$t('step2_financialDetails')}}</h4>
                    </router-link >
                   <span><feather type="chevron-right" ></feather></span>
                </li>
                <li  class="nav-item d-flex align-items-center text-nowrap">
                    <router-link :style="{pointerEvents: 'none'}" to="/step3" :class="($route.name == 'fxView.step_three')?'active':''">
                        <figure><img src="../../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
                        <h4>{{ $t('step3_Questions') }}</h4>
                    </router-link >
                   <span><feather type="chevron-right" ></feather></span>
                </li>
                <li  class="nav-item d-flex align-items-center text-nowrap"> 
                    <router-link :style="{pointerEvents: 'none'}" to="/step4" :class="($route.name == 'fxView.step_four')?'active':''">
                        <figure><img src="../../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
                        <h4>{{$t('steps_heading2')}}</h4>
                    </router-link >
                   <span><feather type="chevron-right" ></feather></span>
                </li>
                <li class="nav-item last d-flex align-items-center text-nowrap" >                       
                    <router-link :style="{pointerEvents: 'none'}" class="mr-0" to="/step5" :class="($route.name == 'fxView.step_five')?'active':''">
                        <figure><img src="../../../../static/fxView/images/cloud-computing.svg" alt="fxView"></figure>
                        <h4>{{$t('steps_heading3')}}</h4>
                    </router-link> 
                </li>
            </ul>
        </div>
        <router-view />
    </div>
</template>
<script>
   import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'steps',
        mixins: [fxViewMixins],
        data() {
            return {

                
            }
        }, 
        
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/steps.vue